import './job-search.scss';

class JobSearch {
    constructor($element) {
        this.$jobSearch = $element;
        this.$jobPerPageSelector = this.$jobSearch.querySelector('[data-job-per-page-selector="root"]');

        this.initialize();
    }

    initialize() {
        if (this.$jobPerPageSelector) {
            this.$jobPerPageSelector.onchange = () => {
                this.changePageResults(this.$jobPerPageSelector.value);
            };
        }
    }

    changePageResults (jobsPerPage) {
        const urlObject = new URL(window.location);
        urlObject.searchParams.set('page', '1'); // reset the page pagination param always to 1 if change the jobs per page amount to prevent no results on page
        urlObject.searchParams.set('job-number', jobsPerPage);

        history.replaceState(history.state, '', urlObject.toString());
        location.reload();
    }
}

export { JobSearch };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    const $$jobSearch = $context.querySelectorAll('[data-job-search="root"]');

    if ($$jobSearch.length > 0) {
        $$jobSearch.forEach(($jobSearch) => {
            const jobSearch = new JobSearch($jobSearch); // eslint-disable-line
        });
    }
});